import useTranslation from 'hooks/useTranslation'
import { useState } from 'react'

const data = [{
  question: 'whatDoesMagMean',
  answer: 'warehouse',
}, {
  question: 'whatIsTheAppFor',
  answer: 'forRentingAndManagingMags',
}, {
  question: 'canICancelMyRentalBeforeTheDeadline',
  answer: 'yesYouCanCancelYourRentalAtAnyTime',
}]

const FaqItem = ({ question, answer }) => {
  const [selected, select] = useState(false)
  const { t } = useTranslation('help')

  return (
    <div
      className='list__item'
      onClick={() => { select(!selected) }}>

      <div className='group'>
        <p>{t(question)}</p>
        <div className={`item__arrow --${selected ? 'down' : 'up'}`}></div>
      </div>

      {selected && <div><i>{t(answer)}</i></div>}
    </div>
  )
}

const Faq = () => {
  return (
    <div className='help__faq'>
      <h4>FAQ</h4>
      <div className='faq__list'>
        {data.map((e, i) => <FaqItem {...e} key={i} />)}
      </div>
    </div>
  )
}

export default Faq